import { render, staticRenderFns } from "./ProductsTable.vue?vue&type=template&id=0a889954&scoped=true"
import script from "./ProductsTable.vue?vue&type=script&lang=js"
export * from "./ProductsTable.vue?vue&type=script&lang=js"
import style0 from "./ProductsTable.vue?vue&type=style&index=0&id=0a889954&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a889954",
  null
  
)

export default component.exports